'use client';

import { useGetServiceGroupsQuery } from '@/features/service-types/api/service-typesApi';
import { SmartInput } from '@web/ui';

type ServiceGroupFilterSelectProps = {
  value: string;
  onChange: (value: string) => void;
};

export function ServiceGroupFilterSelect({
  value,
  onChange,
}: ServiceGroupFilterSelectProps) {
  const { data } = useGetServiceGroupsQuery({
    page_size: 100,
    show_archived: false,
  });

  const options = [
    { value: 'all', label: 'All groups' },
    { value: 'ungrouped', label: 'Ungrouped' },
    ...((data?.data?.results ?? []).map((serviceGroup) => ({
      value: serviceGroup.id,
      label: serviceGroup.name,
    })) as Array<{ value: string; label: string }>),
  ];

  return (
    <div style={{ minWidth: 190 }}>
      <SmartInput
        type="select"
        name="service-group-filter-select"
        size="small"
        value={value}
        options={options}
        onChange={(nextValue) => onChange(String(nextValue))}
      />
    </div>
  );
}
